import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';import moment from 'moment';

export default [
  {
    name: 'name',
    label: i18n('entities.apiKey.fields.name'),
    schema: schemas.string(
      i18n('entities.apiKey.fields.name'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'permissions',
    label: i18n('entities.apiKey.fields.permissions'),
    schema: schemas.stringArray(
      i18n('entities.apiKey.fields.permissions'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'value',
    label: i18n('entities.apiKey.fields.value'),
    schema: schemas.string(
      i18n('entities.apiKey.fields.value'),
      {},
    ),
  },
  {
    name: 'expiresAt',
    label: i18n('entities.apiKey.fields.expiresAt'),
    schema: schemas.datetime(
      i18n('entities.apiKey.fields.expiresAt'),
      {},
    ),
   render: (value) => value && value instanceof Date ? moment(value).format('YYYY-MM-DD HH:mm') : value,
  },
  {
    name: 'requestsUsage',
    label: i18n('entities.apiKey.fields.requestsUsage'),
    schema: schemas.integer(
      i18n('entities.apiKey.fields.requestsUsage'),
      {},
    ),
  },
  {
    name: 'requestsLimit',
    label: i18n('entities.apiKey.fields.requestsLimit'),
    schema: schemas.integer(
      i18n('entities.apiKey.fields.requestsLimit'),
      {},
    ),
  },
  {
    name: 'bandwidthUsage',
    label: i18n('entities.apiKey.fields.bandwidthUsage'),
    schema: schemas.integer(
      i18n('entities.apiKey.fields.bandwidthUsage'),
      {},
    ),
  },
  {
    name: 'allowedIPs',
    label: i18n('entities.apiKey.fields.allowedIPs'),
    schema: schemas.string(
      i18n('entities.apiKey.fields.allowedIPs'),
      {},
    ),
  },
];